import { render } from "./ReihenhausStep4.vue?vue&type=template&id=73bcca62&scoped=true"
import script from "./ReihenhausStep4.vue?vue&type=script&lang=js"
export * from "./ReihenhausStep4.vue?vue&type=script&lang=js"

import "./ReihenhausStep4.vue?vue&type=style&index=0&id=73bcca62&scoped=true&lang=css"

import exportComponent from "/Users/a98ca8a/projects/immo-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73bcca62"]])

export default __exports__